export enum MenuTabs {
  SETTINGS = "gamesettings",
  RULES = "gamerules",
  HISTORY = "gamehistory",
  PAYTABLE = "paytable"
}
